module.exports = __webpack_public_path__ + "static/transfer_request6-a6015069981050596e589241c168b180.png";